import { render, staticRenderFns } from "./imageMulti.vue?vue&type=template&id=3bcaa0e8&"
import script from "./imageMulti.vue?vue&type=script&lang=js&"
export * from "./imageMulti.vue?vue&type=script&lang=js&"
import style0 from "./imageMulti.vue?vue&type=style&index=0&id=3bcaa0e8&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcaa0e8')) {
      api.createRecord('3bcaa0e8', component.options)
    } else {
      api.reload('3bcaa0e8', component.options)
    }
    module.hot.accept("./imageMulti.vue?vue&type=template&id=3bcaa0e8&", function () {
      api.rerender('3bcaa0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/imageMulti.vue"
export default component.exports